import { createStore, applyMiddleware } from 'redux'

import { createFilter } from 'redux-persist-transform-filter';
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { routerMiddleware } from 'react-router-redux'
import thunk from 'redux-thunk'
import logger from 'redux-logger';

// import logger from '../middlewares/logger'
import apiMiddleware from '../middlewares/authApi';
import rootReducer from '../reducers'


export default (history) => {
  const persistedFilter = createFilter(
    'auth', ['access', 'refresh', 'groups', 'username']

  );

  const reducer = persistReducer(
    {
      key: 'polls',
      storage: storage,
      whitelist: ['auth'],
      transforms: [persistedFilter]
    },
    rootReducer
  )
  let store
  if (process.env.NODE_ENV === 'production') {
    store = createStore(
      reducer,
      applyMiddleware(
        apiMiddleware,
        thunk,
        //logger,
        routerMiddleware(history))
    )
  } else {
    store = createStore(
      reducer,
      window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
      applyMiddleware(
        apiMiddleware,
        thunk,
        logger,
        routerMiddleware(history))
    )
  }


  return store
}


// WEBPACK FOOTER //
// ./src/store/index.js